import type { AdPlacementConfig, AdSizeMappinConfig } from 'interfaces/ads/Ad';

const BYPASS_LEADERBOARD = 'adBypass:Leaderboard';
const BYPASS_SOV_SPONSORSHIP = 'adBypass:SOVSponsorship';

/** Matches GAM Leaderboard placement size mappings when direct-sold bypass applies. */
const LEADERBOARD_DIRECT_SOLD_SIZE_MAPPINGS: AdSizeMappinConfig[] = [
  {
    mediaTypes: ['banner'],
    size: [
      [970, 250],
      [970, 90],
      [970, 66],
      [728, 90],
    ],
    viewport: { size: [1024, 0] },
  },
  {
    mediaTypes: ['banner'],
    size: [
      [728, 90],
      [970, 90],
    ],
    viewport: { size: [768, 0] },
  },
  {
    mediaTypes: ['banner'],
    size: [
      [300, 50],
      [320, 50],
    ],
    viewport: { size: [0, 0] },
  },
];

const slotSizesFromMappings = (mappings: AdSizeMappinConfig[]): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const m of mappings) {
    for (const [w, h] of m.size) {
      const key = `${w}x${h}`;
      if (!seen.has(key)) {
        seen.add(key);
        out.push(key);
      }
    }
  }
  return out;
};

export const checkForDirectSoldAd = (
  tags: string[] | undefined,
  ctype: string,
  placementName: string,
  _placementConfig?: AdPlacementConfig,
) => {
  const isBypassed =
    (placementName === 'Leaderboard' && tags?.includes(BYPASS_LEADERBOARD)) ||
    tags?.includes(BYPASS_SOV_SPONSORSHIP) ||
    ctype === 'homepage';
  return isBypassed
    ? {
        sizeMappings: LEADERBOARD_DIRECT_SOLD_SIZE_MAPPINGS,
        slotSize: slotSizesFromMappings(LEADERBOARD_DIRECT_SOLD_SIZE_MAPPINGS),
      }
    : { sizeMappings: null, slotSize: null };
};
